export const orgIdSelector = (state) => state.app?.orgId;

export const deliverySettingSelector = (state) => state.app?.deliverySetting;
